import apiFetch from '@scale/frontend-lib/api-fetch';
import {
  ChatTaskInvokeToolOutput,
  ChatTaskInvokeToolPollOutput,
  ChatTaskInvokeToolPollOutputSuccess,
} from '@scale/shared/chatTaskTools/types';

export const pollChatToolStatusToCompletion = async (
  jobId: string,
  toolId: string,
): Promise<ChatTaskInvokeToolPollOutputSuccess<unknown>> => {
  const pollInterval = 5000; // 5 seconds
  const pollLimit = 5 * 60 * 1000; // 5 minutes
  const startTime = Date.now();

  while (Date.now() - startTime < pollLimit) {
    await new Promise(resolve => setTimeout(resolve, pollInterval));
    const response = await apiFetch<ChatTaskInvokeToolPollOutput<ChatTaskInvokeToolOutput>>(
      null,
      `internal/genai/chatToolStatus/${encodeURIComponent(jobId)}`,
      {
        method: 'POST',
        body: {
          toolId,
        },
      },
    );
    if (response.complete) {
      return response;
    }
  }
  return {
    complete: true,
    result: {
      status: 'EXCEPTION',
      transcriptText: 'Polling timed out',
    },
  };
};
